import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Juan David Nieto
 */
/**
 * Custom con funciones adicionales al formulario de envasado produccion 
 * Se formatean las tablas que contienen columnas con valores de precios
 **/
class CustomInformePorFicha extends FormJaivana.form {
    constructor(props) {
        super(props);
        this.initForm                                       =   this.initForm.bind(this);
        this.recuperaItemsTablas                            =   this.recuperaItemsTablas.bind(this);
        this.gridOptionsMaterialEmpaque                     =   Object.assign({}, this.gridOptions); 
        this.gridOptionsProductoTerminado                   =   Object.assign({}, this.gridOptions); 
        this.gridOptionsItems                               =   Object.assign({}, this.gridOptions); 
        this.gridOptionsAjustesTraslados                    =   Object.assign({}, this.gridOptions);
        this.gridOptionsGranel                              =   Object.assign({}, this.gridOptions); 
        this.showTables                                     =   this.showTables.bind(this);
        this.infoFicha                                      =   this.infoFicha.bind(this);
        this.material_empaque                               =   [];
        this.producto_terminado                             =   [];
        this.items                                          =   [];
        this.ajustes_traslados                              =   [];
        this.costo_granel                                   =   [];
        this.formatPrecios                                  =   this.formatPrecios.bind(this);
        this.formatPrecioTot                                =   this.formatPrecioTot.bind(this);
        this.formatCostoUnitGranel                          =   this.formatCostoUnitGranel.bind(this);
        this.formatCostoTotGranel                           =   this.formatCostoTotGranel.bind(this);
        this.formatCostoUnitMatEmp                          =   this.formatCostoUnitMatEmp.bind(this);
        this.formatCostoTotMatEmp                           =   this.formatCostoTotMatEmp.bind(this);
        this.formatCostoUnitProdTerm                        =   this.formatCostoUnitProdTerm.bind(this);
        this.formatCostoTotProdTerm                         =   this.formatCostoTotProdTerm.bind(this);
        this.formatPrecioUnitTras                           =   this.formatPrecioUnitTras.bind(this);
        this.traerDatos                                     =   this.traerDatos.bind(this);
    }

    initForm(){
        console.log('Informe Fichas, @version:1.01.0024 @author: Mario A. Sepúlveda');
        this.getField("ver_ajustes_traslados").setOnChange(this.showTables);
        this.getField("btn_buscar").setClick(this.traerDatos);
        this.getField("lote_ficha").setOnChange(this.showTables);
    }


    traerDatos(){
        
        let datos = {
            datos:{
                value:this.getField("lote_ficha").getValue()
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'resumen_ficha', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.recuperaItemsTablas,
            error: this.error_,
            general: this.generalFormatPmv
        });
    }

    showTables(){//Limpia y borra las tablas
        this.gridOptionsProductoTerminado['rowData']        = [];
        this.gridOptionsAjustesTraslados['rowData']         = [];
        this.gridOptionsMaterialEmpaque['rowData']          = [];
        this.gridOptionsGranel['rowData']                   = [];
        this.gridOptionsItems['rowData']                    = [];
        this.getField('producto_terminado').toggle(false);
        this.getField('ajustes_traslados').toggle(false);
        this.getField('material_empaque').toggle(false);
        this.getField("info_ficha").setItemsFichas([]);
        this.getField("info_ficha").setVisible(false);
        this.getField('costo_granel').toggle(false);
        this.getField('items').toggle(false);

    }

    infoFicha(data){
        this.getField("info_ficha").setVisible(true);
        this.getField("info_ficha").setItemsFichas(data.data);
    }

    recuperaItemsTablas(data){//Recupera data del servicio
        console.log("datos del servicio", data.data);
        this.material_empaque     =   data.data[0].material_empaque;
        this.producto_terminado   =   data.data[0].producto_terminado;
        this.items                =   data.data[0].items;
        this.ajustes_traslados    =   data.data[0].ajustes_traslados;
        this.costo_granel         =   data.data[0].costo_granel; 

        if(data.data[0].material_empaque)
            data.data[0].material_empaque.map(item => {
                item.costo_unitario = item.costo_unitario.toFixed(2);
                item.costo_total = item.costo_total.toFixed(2);
                return item;
            }); 

        if(data.data[0].producto_terminado)
            data.data[0].producto_terminado.map(item => {
                item.costo_unitario = item.costo_unitario.toFixed(2);
                item.costo_total = item.costo_total.toFixed(2);
                return item;
            }); 

        if(data.data[0].items)
            data.data[0].items.map(item => {
                item.costo_unitario = item.costo_unitario.toFixed(2);
                item.costo_total = item.costo_total.toFixed(2);
                return item;
            }); 
        if(data.data[0].costo_granel)
            data.data[0].costo_granel.map(item => {
                item.costo_unitario = item.costo_unitario.toFixed(2);
                item.costo_total = item.costo_total.toFixed(2);
                return item;
            });  
        //se recorre el arreglo de la tabla para formatear con 2 decimales el campo de costo_unitario

        if(data.data[0].ajustes_traslados)
            data.data[0].ajustes_traslados.map(item => {
                item.costo_unitario = item.costo_unitario.toFixed(2);
                return item;
            }); 

        //console.log('Info Ficha---',data)
        this.infoFicha(data);
        //Tabla Costos Materia Prima
        if (data.estado_p === 200 && this.items !== undefined && this.items.length > 0) 
        {
        let configCell = new Map();
        this.gridOptionsItems['rowData'] = this.items;
        configCell.set("costo_unitario", {cellRenderer: this.formatPrecios,cellStyle: { textAlign: "right" },field: "costo_unitario",});
        configCell.set("costo_total", {cellRenderer: this.formatPrecioTot,cellStyle: { textAlign: "right" },field: "costo_total",});
        this.gridOptionsItems.paginationPageSize = 100;
        this.getField('items').toggle(true);
        this.getField('items').initData(this.gridOptionsItems, configCell);
        }else{
            this.getField('items').toggle(false);
        } 

        //Tabla Costos Material Empaque
        if (data.estado_p === 200 && this.material_empaque !== undefined && this.material_empaque.length > 0) 
        {
        let configCell = new Map();
        this.gridOptionsMaterialEmpaque['rowData'] = this.material_empaque;
        configCell.set("costo_unitario", {cellRenderer: this.formatCostoUnitMatEmp,cellStyle: { textAlign: "right" },field: "costo_unitario",});
        configCell.set("costo_total", {cellRenderer: this.formatCostoTotMatEmp,cellStyle: { textAlign: "right" },field: "costo_total",});
        this.gridOptionsMaterialEmpaque.paginationPageSize = 100;
        this.getField('material_empaque').toggle(true);
        this.getField('material_empaque').initData(this.gridOptionsMaterialEmpaque, configCell);
        }else{
            this.getField('material_empaque').toggle(false);
        }

        //Tabla Ajustes y Traslados
        if (data.estado_p === 200 && this.ajustes_traslados !== undefined && this.ajustes_traslados.length > 0 && this.getField("ver_ajustes_traslados").getValue() === 'S') 
        {
        let configCell = new Map();
        this.gridOptionsAjustesTraslados['rowData'] = this.ajustes_traslados;
        configCell.set("costo_unitario", {cellRenderer: this.formatPrecioUnitTras,cellStyle: { textAlign: "right" },field: "costo_unitario",});
        this.gridOptionsAjustesTraslados.paginationPageSize = 100;
        this.getField('ajustes_traslados').toggle(true);
        this.getField('ajustes_traslados').initData(this.gridOptionsAjustesTraslados, configCell);
        }else{           
        this.getField('ajustes_traslados').toggle(false);
        }
        
        //Tabla Costos Producto Terminado
        if (data.estado_p === 200 && this.producto_terminado !== undefined && this.producto_terminado.length > 0) 
        {
        let configCell = new Map();
        this.gridOptionsProductoTerminado['rowData'] = this.producto_terminado;
        configCell.set("costo_unitario", {cellRenderer: this.formatCostoUnitProdTerm,cellStyle: { textAlign: "right" },field: "costo_unitario",});
        configCell.set("costo_total", {cellRenderer: this.formatCostoTotProdTerm,cellStyle: { textAlign: "right" },field: "costo_total",});

        //costo_unitario y costo_total
        this.gridOptionsProductoTerminado.paginationPageSize = 100;
        this.getField('producto_terminado').toggle(true);
        this.getField('producto_terminado').initData(this.gridOptionsProductoTerminado, configCell);
        }else{
            this.getField('producto_terminado').toggle(false);
        } 

        //Tabla Costo Producto a Granel
        if (data.estado_p === 200 && this.costo_granel !== undefined && this.costo_granel.length > 0) 
        {
            //console.log("costo_granel",this.costo_granel);
        let configCell = new Map();
        this.gridOptionsGranel['rowData'] = this.costo_granel;
        configCell.set("costo_unitario", {cellRenderer: this.formatCostoUnitGranel,cellStyle: { textAlign: "right" },field: "costo_unitario",});
        configCell.set("costo_total", {cellRenderer: this.formatCostoTotGranel,cellStyle: { textAlign: "right" },field: "costo_total",});
        this.gridOptionsGranel.paginationPageSize = 100;
        this.getField('costo_granel').toggle(true);
        this.getField('costo_granel').initData(this.gridOptionsGranel, configCell);
        }else{
            this.getField('costo_granel').toggle(false);
        }
    }

    formatPrecios(props) {
        return "".formatoPrecio(props.data.costo_unitario);
    }

    formatPrecioTot(props){
        return "".formatoPrecio(props.data.costo_total);
    }

    formatCostoUnitGranel(props) {
        return "".formatoPrecio(props.data.costo_unitario);
    }

    formatCostoTotGranel(props){
        return "".formatoPrecio(props.data.costo_total);
    }

    formatCostoUnitMatEmp(props) {
        return "".formatoPrecio(props.data.costo_unitario);
    }

    formatCostoTotMatEmp(props){
        return "".formatoPrecio(props.data.costo_total);
    }

    formatCostoUnitProdTerm(props) {
        return "".formatoPrecio(props.data.costo_unitario);
    }

    formatCostoTotProdTerm(props){
        return "".formatoPrecio(props.data.costo_total);
    }

    formatPrecioUnitTras(props){
        return "".formatoPrecio(props.data.costo_unitario);
    }

}
FormJaivana.addController("prod-informefichas",CustomInformePorFicha);
export default CustomInformePorFicha;